export const CONFIG = {
  // Authentication Configuration - Okta only
  USE_OKTA_LOGIN: import.meta.env.VITE_USE_OKTA_LOGIN !== 'false', // Default to true

  // Okta SDK configuration
  OKTA_ISSUER: import.meta.env.VITE_OKTA_ISSUER || '',
  OKTA_CLIENT_ID: import.meta.env.VITE_OKTA_CLIENT_ID || '',
  OKTA_REDIRECT_URI:
    import.meta.env.VITE_OKTA_REDIRECT_URI ,
  OKTA_POST_LOGOUT_REDIRECT_URI:
    import.meta.env.VITE_OKTA_POST_LOGOUT_REDIRECT_URI ,
  OKTA_SCOPES: (import.meta.env.VITE_OKTA_SCOPES || 'openid profile email offline_access')
    .split(/[ ,]+/)
    .map((s) => s.trim())
    .filter(Boolean),
  OKTA_PKCE: (import.meta.env.VITE_OKTA_PKCE || 'true') === 'true',

  USE_DYNAMIC_CHUNK_SIZE: import.meta.env.VITE_USE_DYNAMIC_CHUNK_SIZE === 'true',
  FIXED_CHUNK_SIZE: Number.parseInt(import.meta.env.VITE_FIXED_CHUNK_SIZE_MB || '10', 10) * 1024 * 1024, // Convert MB to bytes
  MIN_CHUNK_SIZE: Number.parseInt(import.meta.env.VITE_MIN_CHUNK_SIZE_MB || '1', 10) * 1024 * 1024, // Convert MB to bytes
  MAX_CHUNK_SIZE: Number.parseInt(import.meta.env.VITE_MAX_CHUNK_SIZE_MB || '20', 10) * 1024 * 1024, // Convert MB to bytes

  SPEED_TEST_DURATION: Number.parseInt(import.meta.env.VITE_SPEED_TEST_DURATION || '2000', 10),
  SPEED_SAMPLES: Number.parseInt(import.meta.env.VITE_SPEED_SAMPLES || '3', 10),

  RESUME_STORAGE_KEY: import.meta.env.VITE_RESUME_STORAGE_KEY || 'fileUploadResume',
  RESUME_EXPIRY_HOURS: Number.parseInt(import.meta.env.VITE_RESUME_EXPIRY_HOURS || '24', 10),

  POLLING_INTERVAL: Number.parseInt(import.meta.env.VITE_POLLING_INTERVAL || '2000', 10),

  API_BASE_URL: import.meta.env.VITE_API_URL || import.meta.env.BASE_URL.replace(/\/$/, ''),

  LARGE_FILE_THRESHOLD: Number.parseInt(import.meta.env.VITE_LARGE_FILE_THRESHOLD_MB || '50', 10) * 1024 * 1024, // Convert MB to bytes

  MAX_FILE_SIZE_GB: Number.parseInt(import.meta.env.VITE_MAX_FILE_SIZE_GB || '5', 10),  //5GB default
  MAX_FILE_SIZE: Number.parseInt(import.meta.env.VITE_MAX_FILE_SIZE || '53737482240', 10), // 5GB default
  MIN_FILE_SIZE: Number.parseInt(import.meta.env.VITE_MIN_FILE_SIZE || '1', 10), // 1 byte default

  // Session Configuration
  SESSION_TIMEOUT_MINUTES: Number.parseInt(import.meta.env.VITE_SESSION_TIMEOUT_MINUTES || '20', 10),
  SESSION_WARNING_MINUTES: Number.parseInt(import.meta.env.VITE_SESSION_WARNING_MINUTES || '5', 10),

  // Account Lockout Configuration
  MAX_LOGIN_ATTEMPTS: Number.parseInt(import.meta.env.VITE_MAX_LOGIN_ATTEMPTS || '3', 10),
  LOCKOUT_DURATION_MINUTES: Number.parseInt(import.meta.env.VITE_LOCKOUT_DURATION_MINUTES || '30', 10),

  // Password Policy Configuration
  PASSWORD_EXPIRY_DAYS: Number.parseInt(import.meta.env.VITE_PASSWORD_EXPIRY_DAYS || '45', 10),
  PASSWORD_EXPIRY_WARNING_THRESHOLD_DAYS: Number.parseInt(import.meta.env.VITE_PASSWORD_EXPIRY_WARNING_THRESHOLD_DAYS || '15', 10),

  // File Security Configuration
  ALLOWED_FILE_TYPES: (import.meta.env.VITE_ALLOWED_FILE_TYPES || '.csv').split(',').map(type => type.trim()),

  // CSV Header Configuration - when false, portal accepts CSV with or without headers
  // Header validation is controlled by backend; this is for future UI use if needed
  REQUIRE_CSV_HEADER: import.meta.env.VITE_REQUIRE_CSV_HEADER === 'true',
};